import { createFileRoute } from '@tanstack/react-router';

import { HomePage } from '@/features/homepage/index';

export const Route = createFileRoute('/')({
	component: HomePage,
});
